export default __webpack_public_path__ + "static/media/IR_symbol_paths.2c2a43cf.svg";